import _ from 'lodash';

const reducerConstructor = (state, obj, key) => {
  if (key) {
    return {
      ...state,
      [key]: {
        ...state[key],
        ...obj,
      },
    };
  }
  return {
    ...state,
    ...obj,
  };
};

export const asyncDefaultState = (props) => ({
  loading: false,
  error: null,
  data: {},
  ...props,
});

export const asyncActions = {
  REQUEST: (data) => ({ data }),
  SUCCESS: (data) => ({ data }),
  FAILURE: (error) => ({ error }),
};

export const asyncReducer = (key, defaultState = asyncDefaultState()) => ({
  REQUEST: (state) => {
    const obj = {
      ...defaultState,
      loading: true,
    };
    return reducerConstructor(state, obj, key);
  },
  SUCCESS: (state, { payload }) => {
    const obj = {
      loading: false,
      data: payload.data,
    };
    return reducerConstructor(state, obj, key);
  },
  FAILURE: (state, { payload }) => {
    const obj = {
      loading: false,
      error: payload.error,
    };
    return reducerConstructor(state, obj, key);
  },
});

export const asyncSelector = (collection, key) => {
  if (key) {
    return {
      get: (state) => _.get(state, `${collection}.${key}.data`),
      loading: (state) => _.get(state, `${collection}.${key}.loading`),
      error: (state) => _.get(state, `${collection}.${key}.error`),
    };
  }
  return {
    get: (state) => state[collection].data,
    loading: (state) => state[collection].loading,
    error: (state) => state[collection].error,
  };
};
